import { Stack } from "@mui/material";

import { ClientContent } from "../../../client-content/ClientContent";
import { useClientFileContext } from "../../../context/ClientFileContext";
import { EntryQuestionSection } from "./components/entry-question-section/EntryQuestionSection";
import { OwnClaimDocumentsSection } from "./components/own-claim-documents-section/OwnClaimDocumentsSection";
import { OwnClaimsListSection } from "./components/own-claims-list-section/OwnClaimsListSection";
import { useAssetOwnClaims } from "./hooks/useAssetOwnClaims";

export function OwnClaimsView() {
  const { clientId } = useClientFileContext();
  const { formik, missingFields, onAddMove, onCancelMove } = useAssetOwnClaims(clientId);
  const hasOwnClaims = formik.values.hasOwnClaims === true;

  return (
    <ClientContent formik={formik} missingFields={missingFields}>
      <Stack gap={2}>
        <EntryQuestionSection formik={formik} />
        {hasOwnClaims && (
          <>
            <OwnClaimsListSection formik={formik} />
            <OwnClaimDocumentsSection
              clientId={clientId}
              formik={formik}
              onAddMove={onAddMove}
              onCancelMove={onCancelMove}
            />
          </>
        )}
      </Stack>
    </ClientContent>
  );
}
